import * as React from "react";
import { Switch, Route } from "react-router-dom";

import Browser from "modules/WBS/components/layouts/Browser";
import { ProjectStore } from "modules/project/ProjectStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import LibraryGrid from "modules/library/components/pages/LibraryGrid";
import CostPlanGrid from "modules/costPlan/components/pages/CostPlanGrid";
import { observer } from "mobx-react";
import { ELeftMenuTab } from "common/enums";

@observer
class LeftSideMenuRouter extends React.Component {
  render() {
    let { leftTab } = ProjectStore,
      { developmentSelected } = DevelopmentStore;
    return leftTab === ELeftMenuTab.NAVIGATOR ? (
      <Switch>
        <Route path={`/${developmentSelected.id}/WBS`} component={Browser} />
        <Route path={`/${developmentSelected.id}/viewer`} component={Browser} />
      </Switch>
    ) : leftTab === ELeftMenuTab.LIBRARIES ? (
      <LibraryGrid />
    ) : leftTab === ELeftMenuTab.COST_PLANS ? (
      <CostPlanGrid />
    ) : (
      <React.Fragment />
    );
  }
}

export default LeftSideMenuRouter;



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/LeftSideMenuRouter.tsx